module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "bitget.76135eab.svg";